import React, { useEffect, useMemo, useRef } from 'react';
import { connect } from 'react-redux';
import TStore from '../../../../types/store';
import CalendarDay from '../../../../components/ui/calendar/calendar-day';
import { CalendarDayViewSC } from './calendar-day-view.styled';
import EventItem from '../calendar-view/components/event-item/event-item';

type CalendarDayViewProps = {} & ReturnType<typeof mapStateToProps>;

const CalendarDayView: React.FunctionComponent<CalendarDayViewProps> = ({
  positions,
  dayViewScrollTop,
}) => {
  const Events = useMemo(() => {
    return positions.map((positionedEvent, i) => {
      return (
        <div
          key={i}
          style={{
            ...positionedEvent.position,
            position: 'absolute',
            width: `290px`,
            marginLeft: '100px',
            opacity: positionedEvent.event.eventData?.event.editing ? 1 : 0.3,
          }}
        >
          <EventItem
            dayView={true}
            item={positionedEvent.event.eventData!}
            onClick={() => {}}
            key={i}
          />
        </div>
      );
    });
  }, [positions]);

  const dayRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (dayRef.current) {
      dayRef.current.scrollTo({ top: dayViewScrollTop });
    }
  }, [dayViewScrollTop, dayRef]);

  return (
    <CalendarDayViewSC>
      <div className={'calendar-day-container'} ref={dayRef}>
        <CalendarDay />
        {Events}
      </div>
    </CalendarDayViewSC>
  );
};

const mapStateToProps = (state: TStore) => ({
  positions: state.reservationForm.positions,
  dayViewScrollTop: state.reservationForm.dayViewScrollTop,
});

export default connect(mapStateToProps)(React.memo(CalendarDayView));
